import { PROJECT_DATETIME_FORMAT } from "../../../helpers/constants";
import useTranslator from "../../../hooks/useTranslator";


const GridCard = ({ index, title, value, icon, day, onEdit, showEdit, showDay=true, iconBg }) => {
  const { _t } = useTranslator();

  return (
    <li key={index} className="grid_card">
      <div
        className="gridcard_image"
        style={iconBg ? {
          width: 70, minWidth: 70, height: 70,
          background: iconBg,
          borderRadius: 9.8,
          display: "flex", alignItems: "center", justifyContent: "center",
        } : undefined}
      >
        <img src={icon} alt="total cases" />
      </div>
      <div className="gridcard_content">
        <span className="total">{_t(title, title)}</span>
        <h5>{value}</h5>
        {
          showDay && <span className="day">{day}</span>
        }
      </div>
      {showEdit && onEdit && (
        <div className="gridcard_edit" onClick={onEdit}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.334 2.00004C11.5091 1.82494 11.7169 1.68605 11.9457 1.59129C12.1745 1.49653 12.4197 1.44775 12.6673 1.44775C12.9149 1.44775 13.1601 1.49653 13.3889 1.59129C13.6177 1.68605 13.8256 1.82494 14.0007 2.00004C14.1758 2.17513 14.3147 2.383 14.4094 2.61178C14.5042 2.84055 14.553 3.08575 14.553 3.33337C14.553 3.58099 14.5042 3.82619 14.4094 4.05497C14.3147 4.28374 14.1758 4.49161 14.0007 4.66671L5.00065 13.6667L1.33398 14.6667L2.33398 11L11.334 2.00004Z" stroke="#ee7225" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      )}
    </li>
  );
};

export default GridCard;
